import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import { useLocation } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function AboutVisionMision({ id, scrollToSection, data }) { 

  const location = useLocation();
    
      useEffect(() => {
        // Handle scrolling to this section if the hash matches
        if (location.hash.replace("#", "") === id && scrollToSection) {
          scrollToSection();
        }
      }, [location.hash, id, scrollToSection]); 
  

  return ( 
      <section
        className="about-vision-mission-sec"
        id={id}
      >
        <Container fluid>
          <Row>
            <Col md={12}>
              <Row className="about-vision-mission-div">
                <Col md={6}>
                  <div className="about-mission-div">
                    <div className="mission-img">
                      <img
                        src={
                          apiUrl.apiUrl + `/` + data.mission_image
                        }
                        className="img-fluid"
                        alt="Marquis Real Estate Developer in Dubai"
                      />
                    </div>
                    <div className="mission-content">
                      <h2
                        className="common-head darkGrey"
                        data-aos="fade-right"
                      >
                        {data.mission_title}
                      </h2>
                      <p className="common-para" data-aos="fade-right">
                        {" "}
                        {data.mission_description}
                      </p>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="about-vision-div">
                    <div className="vision-img">
                      <img
                        src={
                          apiUrl.apiUrl + `/` + data.vision_image
                        }
                        className="img-fluid"
                        alt="Marquis Real Estate Developer"
                      />
                    </div>
                    <div className="vision-content">
                      <h2 className="common-head darkGrey" data-aos="fade-left">
                        {data.vision_title}
                      </h2>
                      <p className="common-para" data-aos="fade-left">
                        {data.vision_description}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <div></div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}
export default AboutVisionMision;
